import React from 'react';
import i18n from '@i18n';

import RecentlyVisited from './RecentlyVisited';
import StyledBox from '@/ui/styledBox/StyledBox';

function RecentlyVisitedPage() {
    const styles = {
        paddingLeft: '20px',
        paddingRight: '20px'
    };

    return (
        <StyledBox style={styles}>
            <div className="module-title-box">
                <h1>{i18n('homepage.recently-visited.header')}</h1>
            </div>
            <RecentlyVisited />
        </StyledBox>
    );
}

export default RecentlyVisitedPage;
